import React, { Component } from 'react';
import Notifications2, {notify} from 'react-notify-toast';
import InputMask from 'react-input-mask';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import { connectionGet, connectionPost } from '../../utils/connection';

@inject('userStore')
class Deactivate extends Component {
    constructor(props){
      super(props);
      this.state = {
        client_id:''
      }
    }

    componentDidMount(){
    }

    deactivateAccount = () => {
      post('/v2/deactivate-account', {account: this.state.client_id},{
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        console.log(res.data);
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    handleInputChange = (e) => {
      let value = e.target.value;
      this.setState({client_id:value});
    }

    render(){
      return (
      <React.Fragment>
        <div className="card form-type-combine">
          <h4 className="card-title"><strong>Account Deactivator</strong></h4>
          <div className="card-body">
            <div className="card card-inverse mb-0">
              <input type="text" className="form-control" name="client_id" onChange={this.handleInputChange} value={this.state.client_id}/>
              <br/>
              <button className="btn btn-primary" type="button" onClick={this.deactivateAccount}>Deactivate</button>
            </div>
          </div>
        </div>
      </React.Fragment>
      );
    }
}

export default Deactivate;



// WEBPACK FOOTER //
// ./src/components/business/Deactivate.js